






























import { Component, Vue } from "vue-property-decorator";
import { getCooperationList } from "@/req/homes";

@Component({
  components: {},
})
export default class Home extends Vue {
  public row = [
    {
      name: "买量联运：",
      imgList: [],
    },
    {
      name: "公会联运：",
      imgList: [],
    },
    {
      name: "硬核联运：",
      imgList: [],
    },
  ];
  /**
   * initCooperationList
   */
  public async initCooperationList() {
    const res = await getCooperationList()
    for (let index = 0; index < this.row.length; index++) {
      if (res.code === 200) {
        this.row[index].imgList = res.data.filter(item => item.type === index + 1);
      }
    }
  }
  /**
   * mounted
   */
  public mounted() {
    this.initCooperationList()
  }
}
